import { render } from "./NavBar.vue?vue&type=template&id=b5d9667a&scoped=true"
import script from "./NavBar.vue?vue&type=script&lang=js"
export * from "./NavBar.vue?vue&type=script&lang=js"

import "./NavBar.vue?vue&type=style&index=0&id=b5d9667a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\aryav\\Desktop\\Don't touch this file\\Talreq\\talreq\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5d9667a"]])

export default __exports__